import React, { useState } from 'react';
import PropTypes from 'prop-types';
import './Modal.css';

import InputX from '../form/InputX';
import ModalButton from './ModalButton';

function ModalInput({
  label = null, value, placeholder = null,
  validClick, validLabel, modalHasEntered, inputClassName,
  cancelClick
}) {
  const [valueToButton, setValueToButton] = useState(value);
  const valid = () => {
    validClick(valueToButton);
    cancelClick();
  }
  return (
    <>
      <InputX
        setValueExternal={setValueToButton}
        containerClassName={`flexColumn container-inputV2`}
        labelClassName={`type-regular type-light label`}
        inputClassName={`inputV2 type-regular ${inputClassName}`}
        name={`input_name`} label={label}
        placeholder={placeholder} value={value} type={`text`}
        onClick={valid} modalHasEntered={modalHasEntered}
      />
      <ModalButton label={validLabel} className={`primary`} onClick={valid} />
      <ModalButton label={`Close`} className={`cancel`} onClick={cancelClick} />
    </>
  )
}

ModalInput.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string,
  placeholder: PropTypes.string,
  validClick: PropTypes.func.isRequired,
  validLabel: PropTypes.string.isRequired,
  inputClassName: PropTypes.string,
  cancelClick: PropTypes.func
}

export default ModalInput;
